const countyConfigUserAccessReducer = (state = [{}], action) => {
  switch (action.type) {
    case 'LANDSHARK_COUNTY_CONFIG_USER_ACCESS':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigUserAccessReducer;